import { render, staticRenderFns } from "./commodityWarehouse.vue?vue&type=template&id=773ca8ee&scoped=true&"
import script from "./commodityWarehouse.vue?vue&type=script&lang=js&"
export * from "./commodityWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./commodityWarehouse.vue?vue&type=style&index=0&id=773ca8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ca8ee",
  null
  
)

export default component.exports